export default {
    "validation": {
        "min": "La valeur doit être supérieure ou égale à {min}",
        "max": "La valeur ne peut pas être supérieure à {max}",
        "required": "Ce champ est obligatoire",
        "requiredTrue": "Ce champ doit être positionné",
        "email": "Une adresse e-mail valide est exigée",
        "minLength": "La valeur doit comporter au moins {requiredLength, plural, one {# caractère} other {# caractères}}",
        "maxLength": "La valeur ne peut comporter plus de {requiredLength, plural, one {# caractère} other {# caractères}}",
        "pattern": "La valeur est invalide",
        "unique": "Ce champ doit être unique",
        "integer": "La valeur doit être un entier",
        "number": "La valeur doit être un nombre",
        "date": "",
        "range": "La première valeur doit être inférieure ou égale à la seconde"
    }
};
